module.exports = __webpack_public_path__ + "img/logo-black.dfad8492.png";